import React from 'react';
import Typography from '@hpstellar/core/Typography';
import Modal from '@hpstellar/core/Modal';
import { Cross } from '@hpstellar/core/Icons';

import Drawer from '../../../page/components/drawer';
import RadioButton from '../../../ui/components/radio-button';
import RadioButtonGroup from '../../../ui/components/radio-button-group';

import './configuration-drawer.less';

const configurationDrawer = ({
    animationType = 'slide-in-right',
    isOpen,
    onClose = () => {},
    title = 'Choose Your Option',
    subheader,
    className,
    HeaderComponent,
    onChange = () => {},
    configurations,
    children,
}) => {
    //TODO: stellar modal not closing on isOpen change to false
    // need to address this with stellar team
    if (!isOpen) {
        if (typeof window !== 'undefined' && document?.body?.style) {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
        return null;
    }

    if (children || (configurations && configurations.length > 0)) {
        return (
            <Modal
                animationType={animationType}
                isOpen={isOpen}
                className={`configuration-drawer ${className ? ` ${className}` : ''}`}
                onModalClose={onClose}
            >
                <button type="button" data-modal-action="close" className="closeButton">
                    <Cross size="normal" />
                </button>
                <Typography tag="h2" variant="headingTitleSmall">
                    {title}
                </Typography>
                <div className="clearfix configuration-header">
                    <Typography tag="h4" variant="headingSubheader">
                        {subheader}
                    </Typography>
                    {HeaderComponent && HeaderComponent()}
                </div>
                {children ? (
                    children
                ) : (
                    <RadioButtonGroup name="carepack-module" onChange={onChange}>
                        {configurations.map((c, i) => (
                            <RadioButton
                                key={`${i}-${c.checked}`}
                                label={c.label}
                                title={c.title}
                                info={c.info}
                                checked={c.checked}
                                value={c.value}
                                colorHex={c.colorHex}
                                imageUrl={c.imageUrl}
                                variation="tile"
                                data-modal-action="close"
                            />
                        ))}
                    </RadioButtonGroup>
                )}
            </Modal>
        );
    }
    return null;
};

export default configurationDrawer;
